import { motion } from "framer-motion";
import { Heart, Compass, Shield, Sun } from "lucide-react";

const benefits = [
  {
    icon: Heart,
    title: "Process Difficult Emotions",
    description: "Learn to sit with hard feelings instead of pushing them away. Together, we'll build the tools to understand what your emotions are telling you.",
  },
  {
    icon: Compass,
    title: "Find Clarity & Direction",
    description: "When everything feels overwhelming, therapy can help you sort through the noise and reconnect with what truly matters to you.",
  },
  {
    icon: Shield,
    title: "Build Resilience",
    description: "Life will always have its challenges. Therapy helps you develop the inner strength and flexibility to meet them without losing yourself.",
  },
  {
    icon: Sun,
    title: "Reconnect With Yourself",
    description: "Somewhere along the way, you may have lost touch with who you are. Therapy is a space to come back home to yourself.",
  },
];

const HowTherapyHelps = () => {
  return (
    <section id="how-therapy-helps" className="how-therapy-helps-section py-24 px-6 bg-background">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="how-therapy-helps-heading text-3xl md:text-4xl font-heading font-medium text-foreground mb-4">
            How Therapy Can Help
          </h2>
          <div className="w-16 h-px bg-accent mx-auto" />
        </motion.div>

        <div className="how-therapy-helps-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="benefit-card p-8 rounded-md border border-border bg-secondary/50 text-left"
            >
              <div className="benefit-icon w-14 h-14 rounded-full bg-secondary mb-5 flex items-center justify-center mx-0">
                <benefit.icon className="w-6 h-6 text-accent" strokeWidth={1.5} />
              </div>
              <h3 className="benefit-title text-lg font-heading font-medium text-foreground mb-3 text-left">
                {benefit.title}
              </h3>
              <p className="font-body text-muted-foreground font-light leading-relaxed text-sm text-left">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowTherapyHelps;
